<ng-content></ng-content>

<div>
    <div class="cm-mattress-inspector-container">
        @if ($focusedComponentInstance(); as focusedComponentInstance) {
            @if (focusedComponentInstance !== "root") {
                <cm-inspector-section>
                    <ng-container cm-content>
                        <div class="cm-inspector-header" (click)="focusedComponentInstancePathOneStepUp()">
                            <div matTooltip="Back" class="cm-icon">
                                <i class="far fa-chevron-left"></i>
                            </div>
                            <div class="cm-title">
                                {{ $inspectorHeaderText() }}
                            </div>
                        </div>
                    </ng-container>
                </cm-inspector-section>
            }
        }

        @if ($inspectedNode()) {
            @if ($inspectedCurve(); as inspectedCurve) {
                <cm-mattress-curve-inspector [node]="inspectedCurve"></cm-mattress-curve-inspector>
            }
            @if ($inspectedCut(); as inspectedCut) {
                <cm-mattress-cut-inspector [node]="inspectedCut"></cm-mattress-cut-inspector>
            }
            @if ($inspectedReferenceFrame(); as inspectedReferenceFrame) {
                <cm-mattress-reference-frame-inspector [node]="inspectedReferenceFrame"></cm-mattress-reference-frame-inspector>
            }
            @if ($inspectedComponentInstance(); as inspectedComponentInstance) {
                <cm-mattress-component-instance-inspector [node]="inspectedComponentInstance"></cm-mattress-component-instance-inspector>
            }
            @if ($inspectedComponentGraph(); as inspectedComponentGraph) {
                <cm-inspector-section>
                    <ng-container cm-content>
                        <cm-value-slot [node]="inspectedComponentGraph" [key]="'name'" [label]="'Name'"></cm-value-slot>
                    </ng-container>
                </cm-inspector-section>
            }
            @if ($inspectedGroup(); as inspectedGroup) {
                <cm-inspector-section>
                    <ng-container cm-content>
                        <cm-value-slot [node]="inspectedGroup" [key]="'name'" [label]="'Name'"></cm-value-slot>
                    </ng-container>
                </cm-inspector-section>
            }
            @if ($inspectedMesh(); as inspectedMesh) {
                <cm-mattress-mesh-inspector [node]="inspectedMesh"></cm-mattress-mesh-inspector>
            }
            @if ($inspectedComputedCurve(); as inspectedComputedCurve) {
                <cm-mattress-computed-curve-inspector [node]="inspectedComputedCurve"></cm-mattress-computed-curve-inspector>
            }
            @if ($inspectedComponentGraphGenerator(); as inspectedComponentGraphGenerator) {
                <cm-mattress-component-graph-generator-inspector [node]="inspectedComponentGraphGenerator"></cm-mattress-component-graph-generator-inspector>
            }
            @if ($inspectedTemplateInput(); as inspectedTemplateInput) {
                <cm-input-inspector [node]="inspectedTemplateInput" class="cm-inspector"></cm-input-inspector>
            }
            @if ($inspectedMattressInput(); as inspectedMattressInput) {
                <cm-mattress-input-inspector [node]="inspectedMattressInput"></cm-mattress-input-inspector>
            }
            @if ($inspectedTemplateExport(); as inspectedTemplateExport) {
                <cm-export-inspector [node]="inspectedTemplateExport"></cm-export-inspector>
            }
            @if ($inspectedMattressExport(); as inspectedMattressExport) {
                <cm-mattress-export-inspector [node]="inspectedMattressExport"></cm-mattress-export-inspector>
            }
            @if ($inspectedTemplateOutput(); as inspectedTemplateOutput) {
                <cm-mattress-output-inspector [node]="inspectedTemplateOutput"></cm-mattress-output-inspector>
            }
            @if ($inspectedMattressOutput(); as inspectedMattressOutput) {
                <cm-mattress-output-inspector [node]="inspectedMattressOutput"></cm-mattress-output-inspector>
            }
            @if ($inspectedMathOperator(); as inspectedMathOperator) {
                <cm-math-operator-inspector [node]="inspectedMathOperator"></cm-math-operator-inspector>
            }
            @if ($inspectedMoveMaterial(); as inspectedMoveMaterial) {
                <cm-generic-inspector [node]="inspectedMoveMaterial"></cm-generic-inspector>
            }
            @if ($inspectedValue(); as inspectedValue) {
                <cm-value-inspector [node]="inspectedValue"></cm-value-inspector>
            }
            <div class="cm-section-divider"></div>
        }

        <cm-inspector-section>
            <ng-container cm-content>
                <cm-mattress-component-graph-inspector
                    [node]="$focusedComponentInstanceGraph()"
                    [inspectedNode]="$inspectedNode()"
                    [focusedComponentInstancePath]="$focusedComponentInstancePath()"
                    (focusedComponentInstancePathChanged)="onFocusedComponentInstancePathChanged($event)"
                ></cm-mattress-component-graph-inspector>
            </ng-container>
        </cm-inspector-section>

        <cm-inspector-section>
            <ng-container cm-content>
                <cm-list-item [matMenuTriggerFor]="otherMenu">
                    <ng-container cm-pre-title>
                        <div class="cm-title-icons-container">
                            <i class="far fa-bars"></i>
                        </div>
                    </ng-container>
                    <ng-container cm-title>Other</ng-container>
                </cm-list-item>
                <mat-menu #otherMenu>
                    <button mat-menu-item [matMenuTriggerFor]="standardModelsMenu">
                        <i class="far fa-layer-group"></i>
                        Standard Models
                    </button>
                    <button mat-menu-item [matMenuTriggerFor]="toolsMenu">
                        <i class="far fa-wrench"></i>
                        Tools
                    </button>
                </mat-menu>
                <mat-menu #toolsMenu>
                    <button mat-menu-item (click)="initAsStandardModel()">
                        <i class="far fa-layer-group"></i>
                        Set up as standard model
                    </button>
                    <button mat-menu-item (click)="insertMaterialInputsForMeshes()">
                        <i class="far fa-plug"></i>
                        Add material inputs
                    </button>
                    <button mat-menu-item (click)="removeMaterialInputsForMeshes()">
                        <i class="far fa-plug"></i>
                        Remove material inputs
                    </button>
                    <button mat-menu-item (click)="addDefaultCamera()">
                        <i class="far fa-camera"></i>
                        Add default camera
                    </button>
                    <button mat-menu-item (click)="addDefaultLighting()">
                        <i class="far fa-lightbulb"></i>
                        Add default lighting
                    </button>
                </mat-menu>
                <mat-menu #standardModelsMenu>
                    <cm-template-menu>
                        @for (group of $standardModelSeederGroups(); track group.groupKey) {
                            <cm-template-menu-section>
                                <ng-container cm-section-title>{{ group.groupKey | titlecase }}</ng-container>
                                <ng-container cm-section>
                                    @for (seeder of group.seeders; track seeder.key + seeder.variant) {
                                        @let label = (seeder.key | titlecase) + " — " + (seeder.variant | titlecase);
                                        <cm-list-item (click)="runSeeder(seeder.value, seeder.variant)" [matTooltip]="label">
                                            <ng-container cm-pre-title><i class="far fa-layer-group"></i></ng-container>
                                            <ng-container cm-title>{{ label }}</ng-container>
                                        </cm-list-item>
                                    }
                                </ng-container>
                            </cm-template-menu-section>
                        }
                    </cm-template-menu>
                </mat-menu>
            </ng-container>
        </cm-inspector-section>
    </div>
</div>
